export default {
  authenticated: state => state.authenticated,
  error: state => state.error,
  success: state => state.success,
  loading: state => state.loading,
  formLoading: state => state.formLoading,
  currentUser: state => state.currentUser,
  userPFCont: state => state.userPFCont,
  fiscalYear: state => state.fiscalYear,
  selectedDates: state => state.selectedDates,
  sidebarCollapsed: state => state.sidebarCollapsed,
};



// WEBPACK FOOTER //
// ./src/store/getters.js